import { inject } from '@angular/core';
import { ICalendarDay, IReservation } from '@curbnturf/entities';
import * as UserActions from '@curbnturf/user/src/lib/+state/user.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OrderService } from '../order.service';
import * as OrderActions from './order.actions';

export const requestPrice$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), orderService = inject(OrderService)) =>
    actions$.pipe(
      ofType(OrderActions.requestPrice),
      switchMap((action) => {
        // reload the current user to allow updating the CNT Cash available to the user so they aren't surprised by the actual costs
        store.dispatch(UserActions.reloadCurrentUser());

        return orderService.requestPrice(action.reservation).pipe(
          map((reservation: IReservation) => OrderActions.priceFilled({ reservation })),
          catchError((err) => of(OrderActions.priceError({ error: err }))),
        );
      }),
    ),
  { functional: true },
);

export const requestDays$ = createEffect(
  (actions$ = inject(Actions), orderService = inject(OrderService)) =>
    actions$.pipe(
      ofType(OrderActions.requestDays),
      switchMap((action) =>
        orderService.requestDays(action.siteId, action.reservationId).pipe(
          map((days: ICalendarDay[]) => OrderActions.daysFilled({ days })),
          catchError((err) => of(OrderActions.orderError({ error: err }))),
        ),
      ),
    ),
  { functional: true },
);
